import { Workbook } from 'exceljs';
import moment from 'moment';

export const convertData = async (data) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Data');
    worksheet.columns = [
        { header: 'Date(DD-MM-YYYY)', key: 'date', width: 20 },
        { header: 'Code', key: 'code', width: 15 },
        { header: 'Barcode', key: 'barcode', width: 20 },
        { header: 'Brand', key: 'brand', width: 20 },
        { header: 'Product Description', key: 'name', width: 30 },
        { header: 'Qty', key: 'qty', width: 10 },
        { header: 'isEdit', key: 'isEdit', width: 10 },
        { header: 'customer_sku_price', key: 'customer_sku_price', width: 20 },
        { header: 'customer_sku_final_price', key: 'customer_sku_final_price', width: 25 },
        { header: 'customer_subtotal', key: 'customer_subtotal', width: 20 },
        { header: 'customer_final_subtotal', key: 'customer_final_subtotal', width: 25 },
    ];
    const rows = data?.data?.success_data?.map((row) => ({
        ...row,
        date: row.date ? moment(row.date).format('DD/MM/YYYY') : row.date,
    }));
    worksheet.addRows(rows);
    return await workbook.xlsx.writeBuffer();
};

export const dateValidation = (dataList) => {
    const isValidDate = dataList.every((item) => {
        if (!item.date) return false;
        return moment(item.date).isValid();
    });

    return isValidDate;
};
